import React, { useMemo } from 'react';
import { completeDeliveryStatusCounts, getDeliveryStatusMeta } from '../../Deliveries/statusConfig';
import {
    ReadOnlyStatusCountCard,
    StatusCountLabel,
    StatusCountsGrid,
    StatusCountValue,
} from './styles';

/**
 * Read-only status distribution (dashboard); unlike DeliveryStatusCounts, not interactive.
 * @param {{ items?: Array<{ status: string, count: number }>, loading?: boolean }} props
 */
export default function StatusCountGrid({ items = [], loading = false }) {
    const counts = useMemo(() => completeDeliveryStatusCounts(items), [items]);

    return (
        <StatusCountsGrid aria-label="Entregas por status">
            {counts.map((item) => {
                const meta = getDeliveryStatusMeta(item.status);
                const countLabel = loading && !items.length
                    ? '—'
                    : Number(item.count).toLocaleString('pt-BR');
                return (
                    <ReadOnlyStatusCountCard key={item.status} $colorToken={meta.colorToken}>
                        <StatusCountLabel>{meta.label}</StatusCountLabel>
                        <StatusCountValue>{countLabel}</StatusCountValue>
                    </ReadOnlyStatusCountCard>
                );
            })}
        </StatusCountsGrid>
    );
}
